<script lang="ts">
	import * as Popover from '$lib/components/ui/popover';
	import { getListingPresentation, type ListingBadgeGroup } from '$lib/listing-display';
	import type { ListingsResponse } from '@/pocketbase/pocketbase-types';
	import BadgeEuro from '@lucide/svelte/icons/badge-euro';
	import CircleQuestionMark from '@lucide/svelte/icons/circle-question-mark';
	import Sailboat from '@lucide/svelte/icons/sailboat';
	import Ship from '@lucide/svelte/icons/ship';
	import ShipWheel from '@lucide/svelte/icons/ship-wheel';
	import Sparkles from '@lucide/svelte/icons/sparkles';

	let {
		listing,
		boatKind
	}: {
		listing: {
			kind: ListingsResponse['kind'];
			capitanMode?: ListingsResponse['capitanMode'];
		};
		boatKind?: 'motorboat' | 'sailboat' | string;
	} = $props();

	const presentation = $derived(getListingPresentation(listing));

	function typeIcon(group: ListingBadgeGroup) {
		switch (group) {
			case 'salida_compartida':
				return Sparkles;
			case 'patron_profesional':
				return BadgeEuro;
			case 'lista6_sin_patron':
			case 'sin_patron':
				return ShipWheel;
			default:
				return ShipWheel;
		}
	}

	const TypeIcon = $derived(typeIcon(presentation.badgeGroup));
</script>

<div class="space-y-3">
	<div class="flex flex-wrap items-center gap-2">
		<div
			class="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-sm font-medium text-slate-800"
		>
			{#if boatKind === 'motorboat'}
				<Ship class="mr-2 inline-flex size-4 shrink-0" />
				Motora
			{:else}
				<Sailboat class="mr-2 inline-flex size-4 shrink-0" />
				Velero
			{/if}
		</div>

		<div
			class={`inline-flex items-center rounded-full border px-3 py-1 text-sm font-medium ${presentation.badgeClass}`}
		>
			<TypeIcon class="mr-2 inline-flex size-4 shrink-0" />
			{presentation.shortLabel}
		</div>

		<Popover.Root>
			<Popover.Trigger>
				<CircleQuestionMark class="text-kbblue size-5" />
			</Popover.Trigger>
			<Popover.Content class="w-80 text-sm" side="top">
				<p class="font-semibold">{presentation.label}</p>
				<p class="text-muted-foreground mt-2">{presentation.description}</p>
			</Popover.Content>
		</Popover.Root>
	</div>

	<p class="text-sm leading-relaxed text-gray-600">
		{presentation.description}
	</p>
</div>
